let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kNq8n")).then(() => parcelRequire('jR0Em'));